// extracted by mini-css-extract-plugin
export default {"mapWrapper":"Map_mapWrapper__IApYE"};